import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Button, Form, Alert } from 'react-bootstrap';
import CheckListTransactionService from "../CheckList/CheckListTransactionService";
import CheckListHistoryService from "../CheckList/CheckListHistoryService";
import UserService from "../User/UserService.service";


const UpdateStaffCheckList = () => {


    const { id } = useParams();

    useEffect(() => {
        fetchCheckList(id);
        fetchCheckListHistory(id);
        fetchUserList();
    }, []);

    const [checkList, setCheckList] = useState({
        id: 0,
        check_list_name: '',
        assignee: 0,
        checker: 0,
        checker_name: '',
        assignee_name: '',
        comment: '',
        time_of_day: '',
        status: '',
        grade: '',
        created_at: '',
        updated_at: ''
    });
    const [userList, setUserList] = useState([]);
    const [checkListHistoryList, setCheckListHistoryList] = useState([]);
    const [currentStatus, setCurrentStatus] = useState('');

    const [message, setMessage] = useState(false);

    const onChangeCheckList = (e) => {
        const { name, value } = e.target;

        if (name === 'status' && value !== 'REJECTED' && value !== 'APPROVED') {
            setCheckList({ ...checkList, status: value, grade: '' });
            return;
        }

        setCheckList({ ...checkList, [name]: value });
    }

    const updateCheckList = (e) => {
        e.preventDefault();

        CheckListTransactionService.update(checkList.id, checkList)
            .then(response => {
                const updatedCheckList = response.data;
                const checkListTransactionId = updatedCheckList.id || checkList.id;
                setCheckList(updatedCheckList);
                setCurrentStatus(updatedCheckList.status || checkList.status);

                const checkListHistory = {
                    check_list_transaction_id: checkListTransactionId,
                    comment: updatedCheckList.comment || checkList.comment,
                    user_id: localStorage.getItem('auth_user_id'),
                    status: updatedCheckList.status || checkList.status
                };

                return CheckListHistoryService.create(checkListHistory)
                    .then(() => {
                        setMessage(true);
                        fetchCheckListHistory(checkListTransactionId);
                    });
            })
            .catch(e => {
                console.log(e);
            });
    }

    const fetchUserList = () => {
        UserService.getAll()
            .then(response => {
                setUserList(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }


    const fetchCheckList = (id) => {
        CheckListTransactionService.get(id)
            .then(response => {
                setCheckList(response.data);
                setCurrentStatus(response.data.status);
            })
            .catch(e => {
                console.log("error", e)
            });
    }

    const fetchCheckListHistory = (id) => {
        CheckListHistoryService.fetchByCheckListTransactionId(id)
            .then(response => {
                setCheckListHistoryList(response.data);
            })
            .catch(e => {
                console.log("error", e)
            });
    }

    const statusColor = {
        PENDING: 'orange',
        SENT_TO_SUPERVISOR: '#1976d2',
        APPROVED: 'green',
        REJECTED: 'red',
    };

    const statusOptions = [
        { value: 'PENDING', label: 'PENDING', color: 'orange' },
        { value: 'SENT_TO_SUPERVISOR', label: 'SENT TO SUPERVISOR', color: '#1976d2' },
        { value: 'APPROVED', label: 'APPROVED', color: 'green' },
        { value: 'REJECTED', label: 'REJECTED', color: 'red' }
    ];

    const allowedStatusByCurrentStatus = {
        PENDING: ['PENDING', 'SENT_TO_SUPERVISOR'],
        SENT_TO_SUPERVISOR: ['REJECTED', 'APPROVED'],
        REJECTED: ['PENDING', 'APPROVED'],
        APPROVED: ['PENDING', 'REJECTED']
    };

    const allowedStatusList = allowedStatusByCurrentStatus[currentStatus] || statusOptions.map((status) => status.value);
    const isGradeAvailable = checkList.status === 'REJECTED' || checkList.status === 'APPROVED';
    const getStatusOptionStyle = (status, color) => {
        if (!allowedStatusList.includes(status)) {
            return {
                color: '#9ca3af',
                backgroundColor: '#f3f4f6'
            };
        }

        return { color };
    }

    return (
        <div>
            {message &&
                <Alert variant="success" dismissible>
                    <Alert.Heading>Successfully Updated!</Alert.Heading>
                    <p>
                        Change this and that and try again. Duis mollis, est non commodo
                        luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                        Cras mattis consectetur purus sit amet fermentum.
                    </p>
                </Alert>
            }
            <Form onSubmit={updateCheckList}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Check List Name</Form.Label>
                    <Form.Control type="text" value={checkList.check_list_name} name="check_list_name" placeholder="Enter Check List Name" onChange={onChangeCheckList} disabled />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formAssignee">
                    <Form.Label>Assignee</Form.Label>
                    <Form.Select name="assignee" value={checkList.assignee} onChange={onChangeCheckList}>

                        <option value={0}>Select Assignee</option>
                        {userList.map((user) => (
                            <option value={user.id} key={user.id}>{user.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formChecker">
                    <Form.Label>Checker</Form.Label>
                    <Form.Select name="checker" value={checkList.checker} onChange={onChangeCheckList}>
                        <option value={0}>Select Checker</option>
                        {userList.map((user) => (
                            <option value={user.id} key={user.id}>{user.name}</option>
                        ))}
                    </Form.Select>

                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control type="text" name="comment" placeholder="Enter Comment" onChange={onChangeCheckList} />

                </Form.Group>



                <Form.Group className="mb-3" controlId="formTimeOfDay">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                        name="status"
                        value={checkList.status}
                        onChange={onChangeCheckList}
                        style={{
                            color: statusColor[checkList.status] || 'black',
                            fontWeight: 'bold'
                        }}

                    >
                        <option value="PENDING" style={getStatusOptionStyle('PENDING', 'orange')} disabled={!allowedStatusList.includes('PENDING')}>
                            🟠 PENDING
                        </option>
                        <option value="SENT_TO_SUPERVISOR" style={getStatusOptionStyle('SENT_TO_SUPERVISOR', '#1976d2')} disabled={!allowedStatusList.includes('SENT_TO_SUPERVISOR')}>
                            🔵 SENT TO SUPERVISOR
                        </option>
                        <option value="APPROVED" style={getStatusOptionStyle('APPROVED', 'green')} disabled={!allowedStatusList.includes('APPROVED')}>
                            🟢 APPROVED
                        </option>
                        <option value="REJECTED" style={getStatusOptionStyle('REJECTED', 'red')} disabled={!allowedStatusList.includes('REJECTED')}>
                            🔴 REJECTED
                        </option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formTimeOfDay">
                    <Form.Label>Time of Day</Form.Label>
                    <Form.Select
                        name="time_of_day"
                        value={checkList.time_of_day}
                        onChange={onChangeCheckList}
                        style={{
                            color:
                                checkList.time_of_day === "MORNING"
                                    ? "#f59e0b"
                                    : checkList.time_of_day === "AFTERNOON"
                                        ? "#3b82f6"
                                        : checkList.time_of_day === "EVENING"
                                            ? "#8b5cf6"
                                            : "#000"
                        }}
                        disabled
                    >
                        <option value="">Select Time of Day</option>
                        <option value="MORNING" style={{ color: "#f59e0b" }}>
                            🌅 MORNING
                        </option>
                        <option value="AFTERNOON" style={{ color: "#3b82f6" }}>
                            ☀️ AFTERNOON
                        </option>
                        <option value="EVENING" style={{ color: "#8b5cf6" }}>
                            🌙 EVENING
                        </option>
                    </Form.Select>

                    <Form.Group className="mb-3" controlId="formGrade">
                        <Form.Label>Grade</Form.Label>
                        <Form.Select
                            name="grade"
                            value={checkList.grade}
                            onChange={onChangeCheckList}
                            disabled={!isGradeAvailable}
                        >
                            <option value={0}>Select Grade</option>

                            <option value={1}>❌ 1 - Poor</option>
                            <option value={2}>⚠️ 2 - Needs Improvement</option>
                            <option value={3}>👌 3 - Satisfactory</option>
                            <option value={4}>👍 4 - Good</option>
                            <option value={5}>🏆 5 - Excellent</option>
                        </Form.Select>


                    </Form.Group>

                </Form.Group>

                <Button variant="primary" type="submit">
                    Submit
                </Button>
            </Form>

            <br></br>
            <legend align="center" style={{ fontWeight: 'bold' }} > Check List History </legend>
            <table className="table table-bordered">
                <thead className="table-dark">
                    <tr className="table-secondary">
                        <th>ID</th>
                        <th>Comment</th>
                        <th>User</th>
                        <th>Status</th>
                        <th>Created At</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        checkListHistoryList.map((history) => (
                            <tr key={history.id}>
                                <td>{history.id}</td>
                                <td>{history.comment}</td>
                                <td>{history.user_name || history.name || history.user_id}</td>
                                <td style={{ color: statusColor[history.status] || 'black' }}>{history.status}</td>
                                <td>{history.created_at}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default UpdateStaffCheckList
